<div class="drawer-container">
    <button class="buttonleft2" [ngClass]="{'slide-out-button': isDrawerOpen}" (click)="toggleDrawer(selectedCategory)">
        Categories Search
    </button>
    <div class="drawer" [ngClass]="{'open': isDrawerOpen}">
        <div style="text-align: right;" class="close-button-container">
            <button class="close-button" style="margin-right: 8px;" (click)="clearCategory()">
                Clear
            </button>
            <button class="close-button" (click)="toggleDrawer(selectedCategory)">
                Close
            </button>
        </div>
        <h3 class="headercat" style="padding-left:18px;">Categories</h3>

        <ul id="myUL">
            <li *ngFor="let category of sortedCategories" class="category-itema">
                <span class="caret" [ngClass]="{'caret-down': category.category === categorySelected}">
                    <input style="margin-right: 5px;" type="checkbox"
                        [checked]="category.category === categorySelected"
                        (change)="getProductCategory(category.category, null, null, null)">
                    <a class="sublink1">
                        <div class="divmenubut">
                            {{ category.category }}
                            <span class="count-badge">
                                <span class="count">{{ category.categoryCount }}</span>
                            </span>
                        </div>
                    </a>
                </span>
                <ul class="nested" [ngClass]="{'active': category.category === categorySelected}">
                    <li *ngFor="let subCategory of category.subCategories" class="category-itema2">
                        <span class="caret" [ngClass]="{'caret-down': subCategory.subCategory === subCategorySelected}">
                            <input style="margin-right: 5px;" type="checkbox"
                                [checked]="subCategory.subCategory === subCategorySelected"
                                (change)="getProductCategory(category.category, subCategory.subCategory, null, null)">
                            <a class="sublink2">
                                <div class="divmenubut">
                                    {{ subCategory.subCategory }}
                                    <span class="count-badge2">
                                        <span class="count2">{{ subCategory.subCategoryCount }}</span>
                                    </span>
                                </div>
                            </a>
                        </span>
                        <ul class="nested" [ngClass]="{'active': subCategory.subCategory === subCategorySelected}">
                            <li *ngFor="let category3 of subCategory.subCategory3s" class="category-itema3">
                                <span class="caret" [ngClass]="{'caret-down': category3.subCategory3 === subCategory3Selected}">
                                    <input style="margin-right: 5px;" type="checkbox"
                                        [checked]="category3.subCategory3 === subCategory3Selected"
                                        (change)="getProductCategory(category.category, subCategory.subCategory, category3.subCategory3, null)">
                                    <a class="sublink3">
                                        <div class="divmenubut">
                                            {{ category3.subCategory3 === '' ? 'Other' : category3.subCategory3 }}
                                            <span class="count-badge3">
                                                <span class="count3">{{ category3.subCategory3Count }}</span>
                                            </span>
                                        </div>
                                    </a>
                                </span>
                                <ul class="nested" [ngClass]="{'active': category3.subCategory3 === subCategory3Selected}">
                                    <li *ngFor="let category4 of category3.subCategory4s" class="category-itema4">
                                        <input style="margin-right: 5px; margin-left: 20px;" type="checkbox"
                                            [checked]="category4.subCategory4 === subCategory4Selected"
                                            (change)="getProductCategory(category.category, subCategory.subCategory, category3.subCategory3, category4.subCategory4)">
                                        <a class="sublink4">
                                            <div class="divmenubut">
                                                {{ category4.subCategory4 === '' ? 'Other' : category4.subCategory4 }}
                                                <span class="count-badge4">
                                                    <span class="count4">{{ category4.subCategory4Count }}</span>
                                                </span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>

<div class="underlay" [ngClass]="{'open': isDrawerOpen}" (click)="toggleDrawer(selectedCategory)"></div>
<div class="black-background" [ngClass]="{'open': isDrawerOpen}" (click)="toggleDrawer(selectedCategory)"></div>
